import React, { useCallback, memo } from 'react';
import CheckboxRow from './CheckboxRow';
import BaseFilterPanelContent from './BaseFilterPanelContent';
import ApplicantsOverviewApplicantStatusFilterEnum from '../../Models/ApplicantsOverviewApplicantStatusFilterEnum';
import { useCandidatesOverviewContext } from '../../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';

function StatusFilterPanel(): React.JSX.Element {
    const options = Object.values(ApplicantsOverviewApplicantStatusFilterEnum);

    const { filter, filterBy } = useCandidatesOverviewContext();

    const filterSelection = useCallback(
        (value: string): Array<ApplicantsOverviewApplicantStatusFilterEnum> => {
            return filterBy.filter((item: string) => item === value);
        },
        [filterBy],
    );

    const isSelected = useCallback(
        (value: string): boolean => {
            return filterSelection(value).length > 0;
        },
        [filterBy],
    );

    const handleChange = useCallback(
        (value: number) => {
            let current: Array<ApplicantsOverviewApplicantStatusFilterEnum>;

            if (isSelected(options[value])) {
                current = filterBy.filter((item) => item !== options[value]);
            } else {
                current = [...filterBy, options[value]];
            }

            filter(current);
        },
        [filterBy],
    );

    const reset = useCallback(() => {
        filter([]);
    }, []);

    return (
        <BaseFilterPanelContent resetCallback={reset}>
            <div className="flex flex-col">
                {options.map((item, index) => (
                    <CheckboxRow
                        key={item}
                        id={item}
                        menuItemLabel={item}
                        selected={isSelected(item)}
                        changeCallback={() => handleChange(index)}
                        className="h-10"
                    />
                ))}
            </div>
        </BaseFilterPanelContent>
    );
}

export default memo(StatusFilterPanel);
